import { z } from "zod";

export const questionSchema = z
  .object({
    dimensionId: z.string(),
    questionId: z.string(),
    questionNumber: z.string(),
    comment: z.string().max(500, {
      message: "El comentario no puede tener más de 500 caracteres",
    }),
  })
  .refine(
    (data) => {
      // If the dimensionId is not empty, the questionId must be also not empty
      if (data.dimensionId !== "") {
        return data.questionId !== "";
      }
      return true;
    },
    {
      message: "Selecciona una pregunta.",
      path: ["questionId"], // This will make the error appear on the comment field
    },
  )
  .refine(
    (data) => {
      // If the questionId is not empty, the comment must be also not empty
      if (data.questionId !== "") {
        return data.comment !== "";
      }
      return true;
    },
    {
      message: "Escribe un comentario.",
      path: ["comment"], // This will make the error appear on the comment field
    },
  );

export const reevaluationSchema = z
  .object({
    questions: z.array(questionSchema).min(1).max(3),
  })
  .refine(
    (data) => {
      return data.questions.some((question) => question.dimensionId !== "");
    },
    {
      message: "Selecciona al menos una dimensión.",
      path: ["questions"],
    },
  );
